/* eslint-disable max-len */
import { GetEasyBasketOperationDetailRequest } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/request/GetEasyBasketOperationDetailRequest';
import { GetEasyBasketOperationsRequest } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/request/GetEasyBasketOperationsRequest';
import {
  GET_EASY_BASKET_OPERATION_DETAILS_URL,
  GET_EASY_BASKET_OPERATIONS_URL,
} from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

export function sendEasyBasketOperationsRequest(request: GetEasyBasketOperationsRequest): WebSocketAction {
  return wsSendAction(GET_EASY_BASKET_OPERATIONS_URL, request);
}

export function sendEasyBasketOperationDetailsRequest(request: GetEasyBasketOperationDetailRequest): WebSocketAction {
  return wsSendAction(GET_EASY_BASKET_OPERATION_DETAILS_URL, request);
}
